import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import ThemeColorConstant from "constants/ThemeColorsConstant";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle({
  // define the part you're going to style
  tab: {
    _selected: {
      borderColor: "black",
      borderBottom: `2px solid green ${ThemeColorConstant.secondaryColor}`,
      textColor: ThemeColorConstant.secondaryColor,
    },
  },
  tabpanel: {
    // mx: "-20px",
  },
});

// export the component theme
const ChakraUITabsStyling = defineMultiStyleConfig({ baseStyle });

export default ChakraUITabsStyling;
